<script>
  import ArrowIcon from "./ArrowIcon.svelte";
  import CrossIcon from "./CrossIcon.svelte";
  import EditIcon from "./EditIcon.svelte";
  import MoveIcon from "./MoveIcon.svelte";
  import RemoveIcon from "./RemoveIcon.svelte";

  export let icon = "arrow";
  console.log("icon", icon === "edit", icon);
</script>

{#if icon === "arrow"}
  <ArrowIcon />
{:else if icon === "edit"}
  <EditIcon />
{:else if icon === "remove"}
  <RemoveIcon />
{:else if icon === "cross"}
  <CrossIcon />
{:else if icon === "add"}
  <CrossIcon class="cross-plus-icon" />
{:else if icon === "move"}
  <MoveIcon/>
{/if}
